import { ACTION } from '@talos/kyoko';
import { hasOptionsTradingAccess } from '../../utils/hasOptionsTradingAccess';
import type { ConditionalLayoutSpecRule } from '../conditionalLayoutSpecs';
import { CARE_ORDERS_LAYOUT_TEMPLATE_ID, MANUAL_RFQS_LAYOUT_TEMPLATE_ID, OPTIONS_LAYOUT_TEMPLATE_ID } from '../tokens';
import { CARE_ORDERS_LAYOUT_SPEC } from './CareOrdersLayoutSpec';
import { MANUAL_RFQS_LAYOUT_SPEC } from './ManualRFQsLayoutSpec';
import { OPTIONS_LAYOUT_SPEC } from './OptionsLayoutSpec';

export const TRADING_CONDITIONAL_LAYOUT_SPEC_RULES = {
  [OPTIONS_LAYOUT_TEMPLATE_ID]: {
    layoutSpec: OPTIONS_LAYOUT_SPEC,
    isVisible: conditions => hasOptionsTradingAccess(conditions),
  },
  [CARE_ORDERS_LAYOUT_TEMPLATE_ID]: {
    layoutSpec: CARE_ORDERS_LAYOUT_SPEC,
    isVisible: ({ flags, isAuthorized }) =>
      flags.enableTakerMarketplaceETFRFQFlow && isAuthorized(ACTION.SUBMIT_CARE_ORDER),
  },
  [MANUAL_RFQS_LAYOUT_TEMPLATE_ID]: {
    layoutSpec: MANUAL_RFQS_LAYOUT_SPEC,
    isVisible: ({ flags, isAuthorized }) =>
      flags.enableMakerMarketplaceETFRFQFlow && isAuthorized(ACTION.MANUAL_RFQ_PRICING),
  },
} satisfies Record<string, ConditionalLayoutSpecRule>;
